import { ActualNameCreator } from '../common';

import { IBaseSendMessageParams } from './client';

export const createBaseSendMessageActualNameBase = (text: string): string => {
  return text;
};

export const createBaseSendMessageActualName: ActualNameCreator<
  IBaseSendMessageParams
> = ({ params }) =>
  createBaseSendMessageActualNameBase(params.markup.plainText);
